/**
 * Created by andrey on 07.06.16.
 */

//Common
import '../vendor';



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/vendor.ts